var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback, useEffect, useMemo, useRef, useState } from 'react';
function setupCanvas(canvas) {
    var dpr = window.devicePixelRatio || 1;
    var rect = canvas.getBoundingClientRect();
    canvas.width = rect.width * dpr;
    canvas.height = rect.height * dpr;
    var ctx = canvas.getContext('2d');
    ctx.scale(dpr, dpr);
    return ctx;
}
var MAX_WIDTH = 315;
var MAX_HEIGHT = 24;
var levelOrder = ['Bad', 'Good', 'Best'];
var levelOrderScore = [0, 60, 80, 100];
var levelConf = {
    Bad: {
        label: '欠佳',
        width: (MAX_WIDTH * 0.6) | 0,
        fontColor: '#0D67FF',
        color: [229, 115, 115],
        gradient: ['#629CFF', 'rgba(75,141,255,0.08)'],
        scoreGradient: ['#4B87F0', '#D2E2FF'],
        backgroundColor: 'rgba(98,156,255,0.15)',
        shadowColor: 'rgba(98, 156, 255, 0.40)',
        endScore: 60,
        pointColor: ['RGB(229, 115, 115)', 'RGB(255, 67, 102)'],
    },
    Good: {
        label: '适中',
        width: (MAX_WIDTH * 0.2) | 0,
        fontColor: '#00A276',
        color: [255, 183, 77],
        gradient: ['#00D99D', '#CBFFF1'],
        scoreGradient: ['#0ACB96', '#65FFD4'],
        backgroundColor: 'rgba(0,217,157,0.15)',
        shadowColor: 'rgba(0, 217, 157, 0.40)',
        endScore: 80,
        pointColor: ['RGB(255, 183, 77)', 'RGB(255, 152, 0)'],
    },
    Best: {
        label: '优秀',
        width: (MAX_WIDTH * 0.2) | 0,
        fontColor: '#DF8500',
        color: [0, 217, 157],
        gradient: ['#FF9903', 'rgba(255,218,165,0.29)'],
        scoreGradient: ['#FF9903', '#FFDF9D'],
        shadowColor: 'rgba(255, 153, 3, 0.40)',
        backgroundColor: 'rgba(255,183,77,0.15)',
        endScore: 100,
        pointColor: ['RGB(0, 217, 157)', 'RGB(0, 176, 127)'],
    },
};
var tipEl = document.createElement('div');
var measureTextWidth = function (ctx, text) {
    var width = ctx.measureText(text).width;
    return width;
};
function isInPath(x, y, tx, ty, ctx) {
    var dpr = window.devicePixelRatio || 1;
    ctx.beginPath();
    ctx.arc(tx / dpr, ty / dpr, 10 / dpr, 0, Math.PI * 2, true);
    var ret = ctx.isPointInPath(x, y);
    ctx.closePath();
    return ret;
}
var drawTop = function (layout, ctx) {
    // 设置全局样式
    var leftLableWidth = layout.leftLableWidth, height = layout.height, topLableHeight = layout.topLableHeight;
    var offset = leftLableWidth;
    levelOrder.forEach(function (level, i) {
        var _a = levelConf[level], width = _a.width, gradient = _a.gradient, label = _a.label, fontColor = _a.fontColor;
        // 绘制渐变背景
        var gradientFill = ctx.createLinearGradient(0, 0, 0, 25);
        gradientFill.addColorStop(0, gradient[0]);
        gradientFill.addColorStop(1, gradient[1]);
        ctx.fillStyle = gradientFill;
        ctx.fillRect(offset, 0, width, 25);
        // 绘制标签文本
        var labelWidth = measureTextWidth(ctx, label);
        ctx.fillStyle = fontColor;
        ctx.fillText(label, offset + width / 2 - labelWidth / 2, 18);
        // 绘制垂直虚线
        drawVerticalDashedLine(ctx, offset - 1, 0, height + topLableHeight - 54, 2, 2);
        // 绘制分数文本
        ctx.fillStyle = '#4CAF50';
        ctx.fillText("".concat(levelOrderScore[i]), offset - (i === 0 ? 5 : 9), height + topLableHeight - 40);
        offset += width + 1;
        // 绘制结束的虚线和文本 '100'
        if (i === levelOrder.length - 1) {
            drawVerticalDashedLine(ctx, offset - 2, 0, height + topLableHeight - 54, 2, 2);
            ctx.fillText('100', offset - 2 - 10, height + topLableHeight - 40);
        }
    });
};
var drawLable = function (lable, x, y, ctx) {
    ctx.fillStyle = 'rgba(66, 66, 66, 0.86)';
    ctx.fillText(lable, x, y + 5);
};
function drawVerticalDashedLine(ctx, x, startY, endY, dashLength, gapLength) {
    if (dashLength === void 0) { dashLength = 2; }
    if (gapLength === void 0) { gapLength = 1; }
    ctx.lineWidth = 1;
    ctx.strokeStyle = 'rgba(76, 175, 80, 0.30)';
    ctx.beginPath();
    ctx.setLineDash([dashLength, gapLength]);
    ctx.moveTo(x, startY);
    ctx.lineTo(x, endY);
    ctx.stroke();
    ctx.setLineDash([]); // 重置为实线
}
var drawRoundedRect = function (x, y, width, height, r, fill, stroke, ctx) {
    ctx.save();
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.arcTo(x + width, y, x + width, y + r, r);
    ctx.arcTo(x + width, y + height, x + width - r, y + height, r);
    ctx.arcTo(x, y + height, x, y + height - r, r);
    ctx.arcTo(x, y, x + r, y, r);
    if (fill) {
        ctx.fill();
    }
    if (stroke) {
        ctx.stroke();
    }
    ctx.restore();
};
export function getLevel(score) {
    if (score < 60) {
        return levelConf.Bad;
    }
    else if (score < 80) {
        return levelConf.Good;
    }
    else {
        return levelConf.Best;
    }
}
var drawScore = function (layout, ctx, config, rect, score) {
    var gradient = ctx.createLinearGradient(layout.leftLableWidth + rect.width, 30, layout.leftLableWidth, 30);
    gradient.addColorStop(0, config.scoreGradient[0]);
    gradient.addColorStop(1, config.scoreGradient[1]);
    ctx.fillStyle = gradient;
    // // 设置阴影
    ctx.shadowOffsetX = 0;
    ctx.shadowOffsetY = 4;
    ctx.shadowBlur = 6;
    // ctx.shadowColor = config.shadowColor;
    // 绘制圆角矩形
    var borderRadius = 12;
    drawRoundedRect(rect.x, rect.y, rect.width, rect.height, borderRadius, true, false, ctx);
    ctx.fillStyle = score < 10 ? '#0D67FF' : '#fff';
    var scoreWidth = measureTextWidth(ctx, "".concat(score));
    ctx.fillText("".concat(score), layout.leftLableWidth + rect.width + (score < 10 ? 4 : -scoreWidth - 4), rect.y + 18);
};
var draw = function (layout, dimensions, pathRef, ctx) {
    ctx.font = '16px sans-serif';
    ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
    dimensions.forEach(function (v, i) {
        var _a;
        var config = getLevel(v.score);
        // 绘制圆角矩形
        var borderRadius = 12;
        var x = layout.leftLableWidth;
        var y = 50 + 40 * i;
        // 设置背景颜色
        ctx.fillStyle = config.backgroundColor;
        drawRoundedRect(x, y, MAX_WIDTH, MAX_HEIGHT, borderRadius, true, false, ctx);
        var endPointY = 65 + layout.itemSpacing * i;
        drawLable(v.name, 10, endPointY, ctx);
        var score = (_a = v.score) !== null && _a !== void 0 ? _a : (v.score < 4 ? 4 : v.score);
        drawScore(layout, ctx, config, {
            x: layout.leftLableWidth,
            y: y,
            width: MAX_WIDTH * (score / 100),
            height: MAX_HEIGHT,
        }, v.score);
    });
    drawTop(layout, ctx);
};
var Graph = function (_a) {
    var _b = _a.items, items = _b === void 0 ? [] : _b;
    var ref = useRef(null);
    var pathRef = useRef([]);
    var _c = __read(useState(), 2), ctx = _c[0], setCtx = _c[1];
    var height = useMemo(function () { return 36 * items.length + 50 + 35; }, [items]);
    useEffect(function () {
        if (items.length === 0)
            return;
        var currentCtx = setupCanvas(ref.current);
        setCtx(currentCtx);
        tipEl.style.background = 'rgba(0,0,0,.7)';
        tipEl.style.color = '#fff';
        tipEl.style.borderRadius = '2px';
        tipEl.style.padding = '2px 5px';
        tipEl.style.position = 'absolute';
        tipEl.style.zIndex = '9999';
        tipEl.style.fontSize = '12px';
        tipEl.style.display = 'none';
        document.body.appendChild(tipEl);
    }, [ref, items]);
    useEffect(function () {
        if (ctx) {
            var layout = {
                leftLableWidth: 120,
                topLableHeight: 40,
                itemSpacing: 40,
                height: height,
            };
            draw(layout, items, pathRef.current, ctx);
        }
    }, [ctx, items, height]);
    useEffect(function () {
        console.log(pathRef);
    }, [pathRef]);
    var handleMouseMove = useCallback(function (e) {
        if (ctx) {
            var p = pathRef.current.find(function (p) { return isInPath(e.nativeEvent.offsetX, e.nativeEvent.offsetY, p.x, p.y, ctx); });
            if (p) {
                tipEl.style.left = e.pageX + 10 + 'px';
                tipEl.style.top = e.pageY + 10 + 'px';
                tipEl.innerHTML = p.tips;
                tipEl.style.display = 'block';
            }
            else {
                tipEl.style.display = 'none';
            }
        }
    }, [ctx, pathRef]);
    return _jsx("canvas", { ref: ref, onMouseOut: function () { return (tipEl.style.display = 'none'); }, onMouseMove: handleMouseMove, style: { width: 460, height: height } });
};
export default memo(Graph);
